import axios from "../../../config/axiosConfig";

export const getCatalogosEgresos = () => axios.get("/api/egresos-cheques/catalogos");
export const buscarClientesEgresos = (buscar) => axios.get("/api/egresos-cheques/clientes", { params: { buscar } });

export const getConceptos = () => axios.get("/api/egresos-cheques/conceptos");
export const crearConcepto = (body) => axios.post("/api/egresos-cheques/conceptos", body);

export const getNombres = (params = {}) => axios.get("/api/egresos-cheques/nombres", { params });
export const crearNombre = (body) => axios.post("/api/egresos-cheques/nombres", body);

export const buscarEgresos = (params) => axios.get("/api/egresos-cheques/busqueda", { params });

export const getCatalogosReportes = () => axios.get("/api/egresos-cheques/reportes/catalogos");
export const ejecutarReporte = (params) => axios.get("/api/egresos-cheques/reportes", { params });

export const crearAsiento = (body) => axios.post("/api/egresos-cheques/asientos", body);

export const getResumenSolicitudes = () => axios.get("/api/egresos-cheques/solicitudes/resumen");
export const getBancosSolicitudes = () => axios.get("/api/egresos-cheques/solicitudes/bancos");
export const listarSolicitudes = (params) => axios.get("/api/egresos-cheques/solicitudes", { params });
export const getSolicitud = (id) => axios.get(`/api/egresos-cheques/solicitudes/${encodeURIComponent(id)}`);
export const aprobarSolicitudes = (ids) => axios.post("/api/egresos-cheques/solicitudes/aprobar", { ids });
export const emitirSolicitudes = (items) => axios.post("/api/egresos-cheques/solicitudes/emitir", { items });
export const anularSolicitud = (id) => axios.post(`/api/egresos-cheques/solicitudes/${encodeURIComponent(id)}/anular`);
export const actualizarSolicitud = (id, body) => axios.put(`/api/egresos-cheques/solicitudes/${encodeURIComponent(id)}`, body);

export const previsualizarExtracto = (archivo, mes, year) => {
  const fd = new FormData();
  fd.append("excel", archivo);
  fd.append("mes", mes);
  fd.append("year", year);
  return axios.post("/api/egresos-cheques/extracto/previsualizar", fd);
};
export const previsualizarExtractoTexto = (texto, mes, year) => axios.post("/api/egresos-cheques/extracto/previsualizar-texto", { texto, mes, year });
export const guardarExtracto = (body) => axios.post("/api/egresos-cheques/extracto/guardar", body);

const CONC = "/api/egresos-cheques/extracto/conciliacion";
export const listarConciliacion = (params) => axios.get(CONC, { params });
export const getDisponibles = (params) => axios.get(`${CONC}/disponibles`, { params });
export const getRelaciones = (id) => axios.get(`${CONC}/relaciones`, { params: { id } });
export const getCandidatosBanco = (params) => axios.get(`${CONC}/candidatos-banco`, { params });
export const getTraspasosLibres = (year) => axios.get(`${CONC}/traspasos-libres`, { params: { year } });
export const getCreditosTraspaso = (params) => axios.get(`${CONC}/creditos-traspaso`, { params });
export const enlazarDebitosConciliacion = (body) => axios.post(`${CONC}/enlazar-debitos`, body);
export const enlazarCreditosConciliacion = (body) => axios.post(`${CONC}/enlazar-creditos`, body);
export const marcarCorrectoConciliacion = (body) => axios.post(`${CONC}/correcto`, body);
export const marcarConjuntoCreditos = (body) => axios.post(`${CONC}/conjunto-creditos`, body);
export const vincularCreditosReferencia = (body) => axios.post(`${CONC}/vincular-referencia`, body);
export const enlazarBancoConciliacion = (body) => axios.post(`${CONC}/enlazar-banco`, body);
export const desvincularConciliacion = (body) => axios.post(`${CONC}/desvincular`, body);
export const enlazarTraspasoConciliacion = (body) => axios.post(`${CONC}/enlazar-traspaso`, body);
// Movimientos del extracto de un mes, paginados y con búsqueda en el servidor: { rows, total, page, limit, totales: { debito, credito } }.
export const listarMovimientosExtracto = (params) => axios.get("/api/egresos-cheques/extracto/movimientos", { params });
// todos: true devuelve todos los bancos con movimientos (para el filtro); sin eso, solo los frecuentes (para sugerir al registrar)
export const getBancosExtracto = (todos = false) => axios.get("/api/egresos-cheques/extracto/bancos", { params: todos ? { todos: 1 } : undefined });
export const exportarMovimientosExtracto = (params) => axios.get("/api/egresos-cheques/extracto/movimientos/exportar", { params, responseType: "blob" });
export const crearMovimientoExtracto = (body) => axios.post("/api/egresos-cheques/extracto/movimientos", body);
export const actualizarMovimientoExtracto = (id, body) => axios.put(`/api/egresos-cheques/extracto/movimientos/${encodeURIComponent(id)}`, body);
export const getMovimientoEliminable = (id) => axios.get(`${CONC}/eliminable`, { params: { id } });
export const eliminarMovimientoExtracto = (id) => axios.delete(`${CONC}/movimiento/${encodeURIComponent(id)}`);

const CHQ = "/api/egresos-cheques";
export const anularEgreso = (id) => axios.post(`${CHQ}/cheques/${encodeURIComponent(id)}/anular`);
export const actualizarEgreso = (id, body) => axios.put(`${CHQ}/cheques/${encodeURIComponent(id)}`, body);
export const getSolicitudesParaEnlazar = () => axios.get(`${CHQ}/cheques/solicitudes-enlazar`);
export const enlazarSolicitudEgreso = (id, solicitudId) => axios.post(`${CHQ}/cheques/${encodeURIComponent(id)}/enlazar-solicitud`, { solicitudId });
export const enviarCorreoEgreso = (id) => axios.post(`${CHQ}/cheques/${encodeURIComponent(id)}/correo`);
export const crearFacturaEgreso = (id, body) => axios.post(`${CHQ}/cheques/${encodeURIComponent(id)}/facturas`, body);
export const actualizarFactura = (id, body) => axios.put(`${CHQ}/facturas/${encodeURIComponent(id)}`, body);
export const crearGastoEgreso = (id, body) => axios.post(`${CHQ}/cheques/${encodeURIComponent(id)}/gastos`, body);
export const actualizarGasto = (id, body) => axios.put(`${CHQ}/gastos/${encodeURIComponent(id)}`, body);

export const crearCheque = (body) => axios.post("/api/egresos-cheques/cheques", body);
export const listarCheques = (params = {}) => axios.get("/api/egresos-cheques/cheques", { params });
export const getComprobante = (id) => axios.get(`/api/egresos-cheques/cheques/${encodeURIComponent(id)}`);
export const getComprobantePdf = (id) =>
  axios.get(`/api/egresos-cheques/cheques/${encodeURIComponent(id)}/pdf`, { responseType: "blob" });

export const listarTraspasosDinero = (params = {}) => axios.get("/api/egresos-cheques/traspasos", { params });
export const crearTraspasoDinero = (body) => axios.post("/api/egresos-cheques/traspasos", body);
export const actualizarTraspasoDinero = (id, body) => axios.put(`/api/egresos-cheques/traspasos/${encodeURIComponent(id)}`, body);

export const listarRecibosCredito = (params = {}) => axios.get("/api/egresos-cheques/recibos-credito", { params });
export const crearReciboCredito = (body) => axios.post("/api/egresos-cheques/recibos-credito", body);
export const actualizarReciboCredito = (id, body) => axios.put(`/api/egresos-cheques/recibos-credito/${encodeURIComponent(id)}`, body);

// Tipo de cambio guardado implícitamente en un registro (Bs / USD), con decimales de sobra para no alterar los montos al reeditar.
export const tipoCambioDe = (bolivianos, dolares) => {
  const d = num(dolares);
  return d ? String(Number((num(bolivianos) / d).toFixed(10))) : "";
};

const num = (v) => {
  const n = Number(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

// Mismos montos que calcula el servidor (vista previa antes de guardar): Bs ↔ USD con el
// tipo de cambio y, si hay retención, total = Bs / (1 - %) y retención = total - Bs.
export const calcularMontos = ({ importe, moneda, cambio, retencionPorcentaje = null }) => {
  const imp = num(importe);
  const tc = num(cambio);
  const bolivianos = moneda === "Bolivianos" ? imp : imp * tc;
  const dolares = moneda === "Bolivianos" ? (tc ? imp / tc : 0) : imp;
  let importeTotal = bolivianos;
  let montoRetencion = 0;
  if (retencionPorcentaje !== null) {
    importeTotal = bolivianos / (1 - num(retencionPorcentaje) / 100);
    montoRetencion = importeTotal - bolivianos;
  }
  return { bolivianos, dolares, importeTotal, montoRetencion };
};

export const fmtMoney = (v) =>
  Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtFecha = (v) => (v ? String(v).slice(0, 10) : "-");

export const abrirPdfEnPestana = async (id) => {
  const pdfWindow = window.open("", "_blank");
  if (pdfWindow) {
    pdfWindow.opener = null;
    pdfWindow.document.body.innerHTML =
      '<div style="font-family:Arial,sans-serif;padding:24px;color:#334155">Generando comprobante...</div>';
  }
  try {
    const { data } = await getComprobantePdf(id);
    const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
    if (pdfWindow) pdfWindow.location.replace(url);
    else window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (pdfWindow) pdfWindow.close();
    throw e;
  }
};
